import { Component, forwardRef, AfterViewInit, ChangeDetectorRef, Injector, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { AgendaPlannerModel, AGENDA_PLANNER_TYPE_PERIODE } from '../agenda-planner.model';
import { AbstractWorkflowFormComponent } from '../../../@core/abstract-workflow-form-component';
import * as moment from 'moment';
import { MatDialog } from '@angular/material/dialog';
import { WorkflowComponentsService } from '../../../workflow-components.service';
import { MDAgentPlannerAgentsPickerDialog } from './md-agent-planner-agents-picker-dialog/md-agent-planner-agents-picker-dialog.component';
import { Model_WorkflowComponent } from 'src/app/app.models';
import { KeyValue } from '@angular/common';

@Component({
    selector: 'abw-agenda-planner-form',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AgendaPlannerFormComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => AgendaPlannerFormComponent),
            multi: true
        }
    ],
    templateUrl: './agenda-planner-form.component.html',
    styleUrls: ['./agenda-planner-form.component.scss']
})
export class AgendaPlannerFormComponent extends AbstractWorkflowFormComponent<AgendaPlannerModel, any> implements AfterViewInit {
    daysArray = {
        1: 'Lundi',
        2: 'Mardi',
        3: 'Mercredi',
        4: 'Jeudi',
        5: 'Vendredi',
        6: 'Samedi',
        0: 'Dimanche'
    }
    shifts = [
        'J',
        'N',
        '24H',
        '',
    ];
    users: any[] = []; // Liste des utilisateurs
    selectedUsers: any[] = []; // Utilisateurs sélectionnés
    userEntries: { [user: string]: { [date: number]: string } } = {}; // Stocke les saisies

    constructor(
        private dialog: MatDialog,
        _workflowComponentsService: WorkflowComponentsService,
        _cdf: ChangeDetectorRef,
        _injector: Injector
    ) {
        super(_workflowComponentsService, _cdf, _injector);
    }

    doOpenAgentsPickerDialog() {
        this.dialog.open(MDAgentPlannerAgentsPickerDialog, {
            data: {
                agents: this.users,
                selectedAgentsIds: this.selectedUsers.map(user => user.ID)
            },
            width: '100vw',
            panelClass: 'datasource-designer-modal'
        }).afterClosed().subscribe((selectedAgentsIds?: any[]) => {
            if (selectedAgentsIds) {
                this.selectedUsers = this.users.filter(user => selectedAgentsIds.includes(user.ID));
                this.selectedUsers.forEach(user => {
                    if (!this.userEntries[user.ID]) {
                        this.userEntries[user.ID] = {};
                        Object.keys(this.daysArray).forEach(date => {
                            this.userEntries[user.ID][date] = 'J';
                        });
                    }
                });
                this.onValueChanged(this.userEntries);
                this._cdf.detectChanges();
            }
        });
    }

    onAgendaChanged() {
        this.onValueChanged(this.userEntries);
    }

    removeAgendaEntry(userId: string) {
        if (this.userEntries[userId]) {
            delete this.userEntries[userId];
            this.selectedUsers = this.selectedUsers.filter(user => user.ID !== userId);
            this.onValueChanged(this.userEntries);
        }
    }


    ngAfterViewInit() {
        this.users = this.model.datas.map(d => ({ ID: d[this.model.valueField], FULLNAME: d[this.model.displayField], ABSENT: d.ABSENT }));
        const workflowComponent = (this.model as any).additional as Model_WorkflowComponent;
        const codeClientFormId = this.model.additional.CODE_CLIENT;
        const codeClientFormValue = this._workflowComponentsService.context.formValues[workflowComponent.FORM_ID][codeClientFormId];
        if (!!this.model.additional.UIC_PARAMS.DATASOURCE_AGENDA.DATASOURCE_DATAS[codeClientFormValue]) {
            this.userEntries = this.model.additional.UIC_PARAMS.DATASOURCE_AGENDA.DATASOURCE_DATAS[codeClientFormValue];
            this.selectedUsers = this.users.filter(user => Object.keys(this.userEntries).includes(user.ID));
        }
    }

    get countColumns() {
        return Object.keys(this.daysArray).length + 1;
    }
    
    keepOrder =
        (x: KeyValue<string, any>, y: KeyValue<string, any>): number => {
        return 0
    }

}